
    export default {
        name: "ApiPartners",
        data: () => ({
            apiPartners: [
                { name: "chromecast", logo: "https://cdn.freeconvert.com/logo-chromecast.webp" },
                { name: "verzon", logo: "https://cdn.freeconvert.com/logo-verizon.webp" },
                { name: "netflix", logo: "https://cdn.freeconvert.com/logo-netflix.webp" },
                { name: "yelp", logo: "https://cdn.freeconvert.com/logo-yelp.webp" },
                { name: "adobe", logo: "https://cdn.freeconvert.com/logo-adobe.webp" },
                { name: "ring", logo: "https://cdn.freeconvert.com/logo-ring.webp" },
                { name: "nespresso", logo: "https://cdn.freeconvert.com/logo-nespresso.webp" },
                { name: "atnt", logo: "https://cdn.freeconvert.com/logo-atnt.webp" }
            ]
        })
    }
